import { useRouter } from "next/router";
import styled from "styled-components";

import GlitchText from "../components/GlitchText";
import { Title1 } from "../components/Typography";
import { Button } from "../components/buttons/Button";

interface ErrorProps {
  statusCode: 404 | 500;
}

export const Error = ({ statusCode }: ErrorProps) => {
  const router = useRouter();
  let title: string;

  switch (statusCode) {
    case 500:
      title = "We’re sorry, something went wrong";
      break;
    case 404:
    default:
      title = "We’re sorry, this page could not be found";
  }

  return (
    <ErrorContainer>
      <StatusCode>{statusCode}</StatusCode>
      <StyledTitle>{title}</StyledTitle>
      <StyledButton variant={"primary"} onClick={() => router.push("/")}>
        Return To Safety
      </StyledButton>
    </ErrorContainer>
  );
};

export default Error;

const StatusCode = styled(GlitchText)`
  overflow-x: hidden;
  letter-spacing: 0.05em;
  font-weight: 700;
  text-align: center;
  font-size: 250px;
  @media (max-width: 768px) {
    font-size: 200px;
  }
  @media (max-width: 480px) {
    font-size: 140px;
  }
`;

const ErrorContainer = styled.div`
  margin: var(--subnav-height) auto 0;
  max-width: 530px;
`;

const StyledButton = styled(Button)`
  margin: var(--spacing-xl) auto 0;
  max-width: 250px;
`;

const StyledTitle = styled(Title1)`
  text-align: center;
`;
